<template>

    <div class="page_content module_course" aria-label="Grading Page Content" v-if="permission && permission.version === '5'">
        <course-header :course-id="course.uuid" class="header_course_dashboard"></course-header>
        <div class="row page-content grading">
            <div class="col-11 dasboard-left-section report-Page">
                <div class="col-12">
                  <div class="section_head hd_bdr ace_sec_hd" role="heading" aria-level="2">{{course.title}} Aggregated Diagnostic Reports</div>
                  <b-row>
                        <table class="grading">
                          <thead>
                            <tr>
                                <th class="user-column ace_sec_txt"> Diagnostic Test </th>
                                <th class="attempt-column ace_sec_txt"> Tags </th>
                                <th class="last-column ace_sec_txt"> View </th>
                            </tr>
                          </thead>
                          <tbody v-if="dtkcs.length>0">
                            <tr v-for="dtkc in dtkcs">
                                <td class="user-column ace_sec_txt">
                                	<span class="usr_name ace_sec_txt">{{dtkc.title}}</span>
                                </td>
                                <td class="attempt-column">
									<div class="kc-grade-column">
										<span class="kc_attampt ace_sec_txt">{{getTag(dtkc)}}</span>
									</div>
                                </td>
                                <td class="last-column ace_sec_txt">
                                    <b-button size="sm" class="btn_2" aria-label="grade" :to="{ name: 'aggregatedDignosticTestReport', params: { uuid: course.uuid, assessmentId: dtkc.uuid} }" :disabled="permission.systemPermission.readOnly">
                                        Report
                                    </b-button>
                                </td>
                            </tr>
                          </tbody>
                          <tbody v-else>
                          <tr>
                          <td>
                            <div>
                            Diagnotic Test are not configured for the Course.
                            </div>
                          </td>
                          </tr>
                          </tbody>
                        </table>
                  </b-row>
                </div>
            </div>

        </div>
   </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import CourseNav from './CourseNav'
import CourseHeader from './CourseHeader'

export default {
  name: 'aggregatedDignosticReport',
  props: ['uuid'],
  components: {
    CourseNav,
    CourseHeader
  },

  data: () => {
    return {
      dtkcs: []
    }
  },

  watch: {
  },

  mounted () {
    this.loadPermission().then(res => {
      this.loadCourse()
    })
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadCourseDetail',
      'loadAllDiagnosticTests',
      'loadPermission'
    ]),

    loadCourse () {
      this.loadCourseDetail(this.uuid)
      this.loadAllDiagnosticTests(this.uuid).then(response => {
            this.dtkcs = response
          })
    },
    getTag (content){
        if(content.appliedTagMap.custom_diagnostictest){
            let tag =''
            let tags = content.appliedTagMap.custom_diagnostictest
            return (tags[0].name)
        }
            return 'N/A'
    }
    },

  computed: {
    ...mapState({
      'course': state => state.course.course,
      'permission': state => state.user.permission
    })
  }
}
</script>

<style scoped>
.course-nav {
    background:#e1e1e1;
    min-height: 500px;
}
.coure-nav-list-item {
    background:#e1e1e1;
    border: none;
}

.course-thumbnail {
    background:#f8f9fa;
    min-height: 500px;
}

.course-information {
    margin-top:20px;
}

.course-description {
    padding-top:20px;
}

.activity-row {
    padding-top:20px;
}

.card {
    border: none!important;
}

.card-header {
    background: rgb(245, 245, 245) !important;
}

.card-body {
    background: rgb(245, 245, 245) !important;
}

.report-Page .heading {
    padding: 7px 7px 7px 7px;
    border-bottom: 1px solid #efefef;
    font-size: 20px;
    font-family: robotoSlab_Light;
    margin-bottom:15px;
}
.report-Page {
    padding-top:18px;
}
.report-Page .activity-graph-container {
    border: 1px solid #dbdbdb!important;
    border-radius: 0;
    min-height: 270px;
    font-family: openSans_Regular;
}

.report-Page .label {
    background: #c9e0b2;
    padding: 8px;
    color: #4d4d4d;
    font-size: 19px;
}

.report-Page .graph-area {
    height: 228px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.graph-min-height {
    min-height:251px!important;
}

.report-Page .graph-text {
    text-align: center;
    color: #4d4d4d;
    position: relative;
    top: -42px;
}
.report-Page .dashboard-row {
    min-width:1115px;
    padding-left:15px;
}
.report-Page .left-space {
    padding-left:100px;
}
.report-section {
    height: auto;
    padding-left: 15px;
}

.report-graph {
    flex: 0 0 30%!important;
    max-width: 30%!important;
}

.competency-details-row {
    padding-left:33px;
    height: auto;
}

.competency-details-row .value, .competency-details-row .title {
    width: 100%;
    float: left;
    padding: 8px 8px;
}

.score-column {
    width: 30%;
    display: none;
    margin-top: 15px;
}

.column.progress-column {
    position: relative !important;
    display: none;
    margin-top: 9px;
    padding-top: 0!important;
    padding-bottom: 0!important;
    padding-left: 10px!important;
}

.time-column {
    width: 30%;
    display: none;
}

.column.time-column, .column.resource-time-column {
   height: 44px;
   padding: 0!important;
   display: flex;
   align-items: center;
   justify-content: center;
   margin-top: 9px;
   background: none;
}

.time-value-box {
    padding:10px 15px;
    background:rgb(143, 143, 143);
    color:#fff;
	width:96px;
	text-align:center;
}

.last-activity-value-box {
    padding: 5px 8px;
    background: #8f8f8f;
    color: #fff;
    position: absolute;
    font-size: 12px;
    top: 9px;
    height: 44px;
    width: 94px;
    margin: auto;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.resource-time-column {
    position:relative;
    display: none;
}

.last-activity-column {
    position:relative;
    display: none;
}

.competency_progress {
    width:100%;
    position:static;
}

.table thead {
    background: #f5f5f5;
}

.report-column {
	height:calc(100vh - 290px);
	overflow-y: hidden;
	overflow-x: hidden;
}

.breadcrumb-item {
	max-width: 195px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
@media (max-width: 1024px) {
	.report-column {
		overflow-y:auto;
	}
}

button.attempt-report-close {
    border: 0;
    background: transparent;
    padding: 15px;
    margin: -15px -15px -15px auto;
    cursor: pointer;
    -webkit-appearance: none;
}

.attempt-report-close {
    float: right;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .5;
}


</style>



// WEBPACK FOOTER //
// src/app/course/components/AggregatedDignosticReport.vue